import {BaseService} from "./base.service";

class SpecialtysService extends BaseService {

    constructor() {
        super('api/specialtys')
    }

    specialtiesForSinister() {
        return this.http.get(`api/get-specialties-sinester`).then(response => response.data).catch(err => err.message);
    }

}

export const specialtysService = new SpecialtysService();
